import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df8894d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document-menu" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = { class: "input-wrapper" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pr-2" }, "/", -1))
const _hoisted_6 = { class: "pr-2" }
const _hoisted_7 = { class: "flex justify-center items-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "ml-auto cursor-pointer" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "page-control" }
const _hoisted_12 = { class: "w-full flex justify-center" }
const _hoisted_13 = { class: "text-sm text-gray-300" }
const _hoisted_14 = { class: "main-pdf" }

import { ChevronLeft, ChevronRight, ExternalLinkIcon, Menu, XIcon } from 'lucide-vue-next'
import { ref } from 'vue'
import { ISelectOption } from '@/types/interfaces/common.interface'
import RenderPage from './RenderPage.vue'
/**
 * define props
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentViewer',
  props: {
  docPath: {
    type: String,
    required: true,
  },
  docPageKeyStore: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const bufferCurrentPage = ref<number>(1)
const currentPage = ref<number>(Number(localStorage.getItem(props.docPageKeyStore)) || 1)
const showControlPage = ref<boolean>(false)
const scaleText = ref<string>('1')
const totalPage = ref<number>(1)
const isPageRendering = ref<boolean>(true)

const scaleOption = ref<ISelectOption[]>([
  { label: '25%', value: '0.25' },
  { label: '50%', value: '0.5' },
  { label: '75%', value: '0.75' },
  { label: '100%', value: '1' },
  { label: '125%', value: '1.25' },
  { label: '150%', value: '1.5' },
  { label: '175%', value: '1.75' },
  { label: '200%', value: '2' },
  { label: 'Fit Width', value: 'fit-width' },
  { label: 'Fit Height', value: 'fit-height' },
])

const prevPage = async () => {
  const page = currentPage.value > 1 ? currentPage.value - 1 : currentPage.value
  changePage(page)
}

const nextPage = async () => {
  const page = currentPage.value < totalPage.value ? currentPage.value + 1 : currentPage.value
  changePage(page)
}

const updateStoragePage = () => {
  if (props.docPageKeyStore) localStorage.setItem(props.docPageKeyStore, `${currentPage.value}`)
}

const changePage = (page: number) => {
  if (page <= totalPage.value && page >= 0) {
    currentPage.value = page
  }
  bufferCurrentPage.value = currentPage.value
  updateStoragePage()
}

const validateInputNumber = (event: any) => {
  // Replace all non-digit characters globally (e.g., /[^0-9]/g)
  // or to allow decimals use /[^0-9.]/g and add logic to prevent multiple dots.
  const changedValue = event.target?.value.replace(/\D/g, '')
  const page =
    Number(changedValue) <= totalPage.value && Number(changedValue >= 0)
      ? Number(changedValue)
      : currentPage.value || 1
  changePage(page)
}

const toggleShowPanel = () => {
  showControlPage.value = !showControlPage.value
}

const handelLoadSuccess = (value: { totalPage: number }) => {
  isPageRendering.value = false
  totalPage.value = value.totalPage
}

const onScrollPage = (page: number) => {
  bufferCurrentPage.value = currentPage.value = page
  updateStoragePage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'document-grids': !showControlPage.value, 'document-control-grids': showControlPage.value })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "mr-auto",
        onClick: toggleShowPanel
      }, [
        _withDirectives(_createVNode(_unref(Menu), { size: 20 }, null, 512), [
          [_vShow, !showControlPage.value]
        ]),
        _withDirectives(_createVNode(_unref(XIcon), { size: 20 }, null, 512), [
          [_vShow, showControlPage.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", { onClick: prevPage }, [
          _createVNode(_unref(ChevronLeft), { size: 20 })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bufferCurrentPage).value = $event)),
            type: "number",
            name: "doc_page",
            class: "input-text",
            disabled: isPageRendering.value,
            onInput: validateInputNumber
          }, null, 40, _hoisted_4), [
            [
              _vModelText,
              bufferCurrentPage.value,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(totalPage.value), 1)
        ]),
        _createElementVNode("button", { onClick: nextPage }, [
          _createVNode(_unref(ChevronRight), { size: 20 })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((scaleText).value = $event)),
          class: "scale-option"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scaleOption.value, (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: `s-opt-${opt}`,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_8))
          }), 128))
        ], 512), [
          [_vModelSelect, scaleText.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: __props.docPath,
          target: "_blank"
        }, [
          _createVNode(_unref(ExternalLinkIcon), { size: 20 })
        ], 8, _hoisted_10)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      (showControlPage.value)
        ? (_openBlock(), _createBlock(RenderPage, {
            key: 0,
            "current-page": currentPage.value,
            "doc-path": __props.docPath,
            "scale-text": "fit-width",
            "scroll-style": "smooth",
            "highlight-active": "",
            "can-click-page": "",
            class: "p-4",
            onClickPage: _cache[2] || (_cache[2] = (page) => changePage(page))
          }, {
            "after-page": _withCtx(({ page }) => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(page), 1)
              ])
            ]),
            _: 1
          }, 8, ["current-page", "doc-path"]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, showControlPage.value]
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(RenderPage, {
        "current-page": currentPage.value,
        "doc-path": __props.docPath,
        "scale-text": scaleText.value,
        class: "p-5",
        "detect-scroll": "",
        onLoadSuccess: handelLoadSuccess,
        onChangePage: onScrollPage
      }, null, 8, ["current-page", "doc-path", "scale-text"])
    ])
  ], 2))
}
}

})